<template>
  <footer v-if="$store.state.user.check_is_wxc_domain()  || $store.state.user.check_is_wxcblog_domain()"
          class="mb-3 ml-1 pt-0 text-left text-small haiwaifooter">
    <p class="small d-inline mb-1">Copyright ©{{copyright}} wenxuecity.com</p>
    <div class="row">
      <div class="mr-2"><a href="https://www.wenxuecity.com/aboutus/privacy.shtml" class="small letter">Privacy Policy |</a></div>
      <div class="mr-2"><a href="https://www.wenxuecity.com/aboutus/tou.shtml" class="small letter">Terms of Use |</a></div>
      <div class="mr-2"><a href="https://www.wenxuecity.com/aboutus/wenxuecity.shtml" class="small letter">About</a></div>
    </div>
  </footer>
<footer v-else class="mb-3 pt-0 text-left text-small haiwaifooter">
  <!--  <footer v-else  class="mb-3 ml-1 pt-0 text-left text-small haiwaifooter">-->
  <p class="small d-inline mb-1">Copyright ©{{copyright}} Haiwai.com</p>
    <div class="row ml-0">
      <div class="mr-2"><a href="/privacy" class="small letter">Privacy Policy |</a></div>
      <div class="mr-2"><a href="/tou" class="small letter">Terms of Use |</a></div>
      <div class="mr-2"><a href="/about" class="small letter">About</a></div>
    </div>
  </footer>
</template>
<script>

export default {
  name: 'right-footer',
  components: {
  },
  data(){
     return{
        copyright:new Date().getFullYear()
     }
  }
};
</script>
<style>
footer .haiwaifooter{
  font-size: 13px
}
footer .haiwaifooter p, .haiwaifooter  .small{
  font-size: 12px
}
footer p,footer a{
        color: #8194a5
}
footer .letter{letter-spacing: -0.3px}
</style>
